var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit001(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3954 15.0973C2.43368 14.7527 2.45283 14.5804 2.50496 14.4194C2.55121 14.2765 2.61656 14.1405 2.69923 14.0152C2.79241 13.8739 2.91499 13.7513 3.16014 13.5061L14.1654 2.5009C15.0859 1.58043 16.5782 1.58043 17.4987 2.5009C18.4192 3.42138 18.4192 4.91376 17.4987 5.83424L6.49347 16.8395C6.24832 17.0846 6.12574 17.2072 5.98444 17.3004C5.85907 17.383 5.72311 17.4484 5.58024 17.4946C5.4192 17.5468 5.24691 17.5659 4.90234 17.6042L2.08203 17.9176L2.3954 15.0973Z",
    stroke: "#525252",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit001);
export default __webpack_public_path__ + "static/media/edit-001.83bd8970dee996bf700f4bbcb46c2e39.svg";
export { ForwardRef as ReactComponent };